/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component, Input } from '@angular/core';
import { FittingPrioritizationRowVm } from '../../../models/fitting-prioritization-row-vm';

@Component({
  selector: 'fitting-prioritization-row-template',
  templateUrl: './fitting-prioritization-row-template.component.html',
  styleUrls: ['./fitting-prioritization-row-template.component.scss'],
  standalone: false
})
export class FittingPrioritizationRowTemplateComponent {
  @Input() rowVm: FittingPrioritizationRowVm;
}